import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { EpToastService, IEpTreeViewModel, IEpComponentEventArg, IEpComponentModel } from '@epicor/kinetic';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { FieldAgentClient, Dashboard, SmartView } from 'ep-bt-field-agent-proxy';
import { EpbtFaSmartTilesService } from '../../services/epbt-fa-smart-tiles.service';
import { DisplaySmartTile } from '../../models/display-smart-tile.model';
import { EpbtFaSmartviewsService } from '../../services/epbt-fa-smartviews.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Title } from '@angular/platform-browser';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-smart-tiles',
  templateUrl: './epbt-fa-smart-tiles.component.html',
  styleUrls: ['./epbt-fa-smart-tiles.component.scss']
})
export class EpbtFaSmartTilesComponent implements OnInit {

  customOptions: OwlOptions = {

    loop: false,

    dots: true,

    navSpeed: 700,

    margin: 15,

    nav: true,

    autoWidth: true,

    navText: ['', ''],

    responsiveRefreshRate: 200,

  };
  width = 140;
  webTrackUser: any;
  dashboard: Dashboard[] = [];
  newTile: any[] = [];
  //  testData:any[]=[{title:'1'}, {title:'2'}, {title:'3'}, {title:'4'}, {title:'5'}, {title:'6'}];
  tileHeader: string;
  smartView: SmartView[] = [];

  @Output() refreshSmartViewGrid = new EventEmitter();
  @Output() refreshSmartViewGraph = new EventEmitter();

  constructor(
    private fieldAgentService: EpbtFieldAgentService,
    private client: FieldAgentClient,
    public faSmartTilesService: EpbtFaSmartTilesService,
    private faSmartviewsService: EpbtFaSmartviewsService) { }

  ngOnInit() {
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.faSmartTilesService.dashboards = []; // clear
      this.faSmartTilesService.smartViews = []; // clear
      // this.faSmartTilesService.smartTilesTitle = '';//clear
      // this.faSmartTilesService.navigateTo = "DefaultPage";
      this.addDashboardsSmartTiles();
      setTimeout(() => {
        this.addSmartViewsSmartTiles();
      }, 100);
    });
  }

  addDashboardsSmartTiles() {
    let dashboard = [];
    // Look for the contacts in the service.
    const dashbords = this.faSmartTilesService.dashboards;

    if (dashbords.length == 0) {
      this.client.getDashboardsForUser(this.webTrackUser).subscribe(res => {
        if (res && res.length > 0) {
          // filter by BisTrackCloudAccess
          dashboard = res.filter(x => x.bisTrackCloudAccess);
        }
        // Store the dashboards in the service for quick retrieval next time.
        this.faSmartTilesService.dashboards = dashboard;

        // ..............Start AddDashboardSmartTiles............
        const smartTiles = dashboard.filter(d => d.smartTileLabel != '');
        smartTiles.forEach(item => {
          this.newTile.push({
            badge: 0,
            title: item.smartTileLabel,
            dashboardID: item.dashboardID,
            navigateUrl: 'Graph',
            smartTileWidth: this.width,
            tileType: 1
          });
        });
        // ..start smartTiles show and hide...
        if (smartTiles.length == 0 && !this.faSmartTilesService.isShow) {
          this.faSmartTilesService.isShow = false;
        } else {
          this.faSmartTilesService.isShow = true;
        }
        // ..end..smartTiles  show and hide....
        let badgeValue: number;
        smartTiles.forEach(tileData => {
          const tile = new DisplaySmartTile(tileData.dashboardID, tileData.smartTileLabel, tileData.smartTileSQL, tileData.smartTileType, 0);
          tile.tileSQL = this.faSmartTilesService.parse(tile.tileSQL); // SQLCommandParser
          if (tile.hasWildCards) {
            this.client.getSmartTileBadgeValueDirect(tile.dashboardID, tile.tileSQL).subscribe(res => {
              if (res) {
                badgeValue = res;

                const t = this.newTile.find(i => i.dashboardID == tile.dashboardID);
                if (t) {
                  t.badge = badgeValue;
                }

                this.faSmartTilesService.smartTileData = this.newTile;
                if (this.faSmartTilesService.navigateTo == 'DefaultPage' && this.newTile.length > 1) {
                  this.onTileClick(this.newTile[0]);
                }
              }
            });
          } else {
            this.client.getSmartTileBadgeValue(tile.dashboardID).subscribe(resBadge => {
              // if (resBadge) {
              badgeValue = resBadge;
              const t = this.newTile.find(i => i.dashboardID == tile.dashboardID);
              if (t) {
                t.badge = badgeValue;
              }
              // end
              this.faSmartTilesService.smartTileData = this.newTile;
              if (this.faSmartTilesService.navigateTo == 'DefaultPage' && this.newTile.length > 1) {
                this.onTileClick(this.newTile[0]);
              }
              // }
            });
          }
        });
      });
    }
  }

  addSmartViewsSmartTiles() {
    let smartViews = [];
    // Look for the contacts in the service.
    const smartView = this.faSmartTilesService.smartViews;

    if (smartView.length == 0) {
      this.client.getSmartViewsForUser(this.webTrackUser).subscribe(res => {
        if (res && res.length > 0) {
          smartViews = res;
        }
        // Store the dashboards in the service for quick retrieval next time.
        this.faSmartTilesService.smartViews = smartViews;

        // ..............Start  Add Smart Views smart tiles ............
        const smartTiles = smartViews.filter(d => d.smartTileLabel != '');
        smartTiles.forEach(item => {
          this.newTile.push({
            badge: 0,
            title: item.smartTileLabel,
            dashboardID: item.smartViewID,
            navigateUrl: 'Grid',
            smartTileWidth: this.width,
            tileType: 0
          });
        });
        // ..start smartTiles show and hide...
        if (smartTiles.length == 0 && !this.faSmartTilesService.isShow) {
          this.faSmartTilesService.isShow = false;
        } else {
          this.faSmartTilesService.isShow = true;
        }
        // ..end..smartTiles  show and hide....
        let badgeValue: number;
        smartTiles.forEach(s => {
          const tile = new DisplaySmartTile(s.smartViewID, s.smartTileLabel, s.smartTileSQL, s.smartTileType, 0);
          let parsed: string;
          if (tile.hasWildCards) {
            parsed = this.faSmartTilesService.parseSmartViewSmartTileSQL(tile.tileSQL); // SQLCommandParser
            if (parsed != '') {
              tile.tileSQL = parsed;
              this.client.getSmartTileBadgeValueDirect(tile.dashboardID, tile.tileSQL).subscribe(res => {
                if (res) {
                  badgeValue = res;
                  const t = this.newTile.find(i => i.dashboardID == tile.dashboardID);
                  if (t) {
                    t.badge = badgeValue;
                  }
                  this.faSmartTilesService.smartTileData = this.newTile;
                  if (this.faSmartTilesService.navigateTo == 'DefaultPage' && this.newTile.length > 1) {
                    this.onTileClick(this.newTile[0]);
                  }
                }
              });
            } else {
              // else it was cleared, must be containing DrillDown parameters, will display 0 as badge value
              badgeValue = 0;
            }
          } else {
            this.client.getSmartTileBadgeValueDirect(tile.dashboardID, tile.tileSQL).subscribe(resBadge => {// we not using this api "getSmartViewSmartTileBadgeValue"
              if (resBadge) {
                badgeValue = resBadge;

                const t = this.newTile.find(i => i.dashboardID == tile.dashboardID);
                if (t) {
                  t.badge = badgeValue;
                }
                // end
                this.faSmartTilesService.smartTileData = this.newTile;
                if (this.faSmartTilesService.navigateTo == 'DefaultPage' && this.newTile.length > 1) {
                  this.onTileClick(this.newTile[0]);
                }
              }
            });
          }
        });
      });
    }
  }

  onTileClick(tile) {
    if (tile.navigateUrl == 'Grid') {
      // this.faSmartTilesService.smartTilesTitle = tile.title;

      // this.faSmartTilesService.isShow = true;
      this.faSmartviewsService.smartviewId = tile.dashboardID; // smartView.smartViewID;
      this.faSmartTilesService.navigateTo = tile.navigateUrl; // for checking Graph or Grid
      this.faSmartviewsService.selectedDashboardId = tile.dashboardID; // save dashboard id for smartView details header
      this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
        this.client.getSmartViewsForUser(webTrackUser).subscribe(res => {
          if (res != null) {
            // var headerTitle = res.find(d => d.smartViewID == this.faSmartviewsService.smartviewId);
            // this.faSmartTilesService.smartTilesTitle = headerTitle.name;
            const headerTitle = res.filter(x => x.smartViewID === this.faSmartviewsService.smartviewId).map(x => x.name);
            this.faSmartTilesService.smartTilesTitle = headerTitle[0];
          }

        });
      });
      this.refreshSmartViewGrid.emit(tile.dashboardID); // Just fire the event on "dashboard-smart-tiles.ts"
    } else {

      this.faSmartTilesService.isShow = true;
      this.faSmartTilesService.navigateTo = tile.navigateUrl; // for checking Graph or Grid
      this.faSmartTilesService.smartTilesTitle = tile.title;
      this.refreshSmartViewGraph.emit(tile.dashboardID); // Just fire the event on "dashboard-smart-tiles.ts"
    }
  }
}
